import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation(); // Get the current location (URL)

  return (
    <div className="md:px-20 px-4 md:mb-10 md:mt-10 mb-5 mt-5">
      <div className="bg-[#2E453D] flex md:flex-row md:space-x-6 space-x-1 rounded-md">
        {/* Socials Section */}
        <div className="md:w-1/2  p-2">
          <h3 className="font-bold text-white text-[14px] md:text-[36px] mb-2">Socials</h3>

          <div className="flex flex-wrap justify-start sm:justify-start gap-1.5 md:gap-12 mt-5 mb-5">
            <a href="https://www.facebook.com/profile.php?id=100091754654500" className="hover:opacity-75"><img src="/facebook.png" alt="Facebook" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://www.instagram.com/farmnet.africa/" className="hover:opacity-75"><img src="/instagram.png" alt="Instagram" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://www.tiktok.com/@farmnet_africa" className="hover:opacity-75"><img src="/tiktok.png" alt="TikTok" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://youtube.com/@farmnetafrica?si=vvuSecI94w-LBYpz" className="hover:opacity-75"><img src="/youtube.png" alt="YouTube" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://www.linkedin.com/in/farmnet/" className="hover:opacity-75"><img src="/linkedin.png" alt="LinkedIn" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://www.twitter.com/@FarmNet_africa" className="hover:opacity-75"><img src="/twitter.png" alt="Twitter" className="w-2 h-2 md:w-10 md:h-10" /></a>
            <a href="https://wa.me/+27732372620" className="hover:opacity-75"><img src="/whatsapp.png" alt="WhatsApp" className="w-2 h-2 md:w-10 md:h-10" /></a>
          </div>

          <p className="text-[8px] md:text-[28px] font-bold text-white mt-10 md:mt-24">
            @2025 Farmers Networks
          </p>
        </div>

        {/* Links Section */}
        <div className="md:w-1/2 md:mt-0 ">
          {/* Header and Button inline */}
          <div className="flex flex-row justify-between md:space-x-3 space-x-[43px] items-center">
            <h3 className="font-bold text-white text-[14px] md:text-[36px] md:pt-4">LINKS</h3>

            {/* Conditionally Render the Button */}
            <a href='Register_As_Farm'>

              <button className="bg-[#FDBD26]  mt-1 md:-mt-1 shadow-md shadow-gray-900 md:border-b-[5px] border-b-[3px] border-white text-white font-bold  px-2 py-1 md:w-[400px] md:py-2.5 md:rounded-br-[10px] md:rounded-bl-[10px] rounded-md text-[7px] md:text-[30px] flex items-center justify-end gap-4  text-right">
                Register as a Farmer
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744205132/Expand_right_unwap6.png"
                  alt="Arrow"
                  className="w-4 h-4 md:w-9 md:h-9"
        
                />
              </button>

            </a>
          </div>

          {/* Footer Links */}
          <ul className="md:-space-y-2 -space-y-3 md:mt-1">
            <li><Link to="/Terms_Condition" className="text-[5px] md:text-[30px] text-white hover:underline">Terms and conditions</Link></li>
            <li><Link to="/PrivacyPolicy" className="text-[5px] md:text-[30px] text-white hover:underline">Privacy policy</Link></li>
            <li><Link to="/Data_Policy" className="text-[5px] md:text-[30px] text-white hover:underline">Data Policy</Link></li>
            <li><Link to="/Faqs" className="text-[5px] md:text-[30px] text-white hover:underline">Frequently asked questions (FAQS)</Link></li>
            <li><Link to="/Contact" className="text-[5px] md:text-[30px] text-white hover:underline">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
